// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkyhopPdfHeader {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  margin: 0;
  padding: calc(var(--pdf-spacing) / 2) var(--pdf-spacing) 1rem var(--pdf-spacing);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
}
.SkyhopPdfHeader .SkyhopPdfHeader-Logo,
.SkyhopPdfHeader .SkyhopPdfHeader-Title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.SkyhopPdfHeader .SkyhopPdfHeader-Title {
  text-transform: uppercase;
  text-align: end;
  font-size: 20px;
  font-weight: 600;
  color: #40ade2;
  line-height: 1.2;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/components/SkyhopPdfHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;EACA,gFAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;AACF;AAAE;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;AAAE;EACE,yBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAEJ","sourcesContent":[".SkyhopPdfHeader {\n  position: relative;\n  width: 100%;\n  background-color: #ffffff;\n  margin: 0;\n  padding: calc(var(--pdf-spacing) / 2) var(--pdf-spacing) 1rem var(--pdf-spacing);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  .SkyhopPdfHeader-Logo,\n  .SkyhopPdfHeader-Title {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  .SkyhopPdfHeader-Title {\n    text-transform: uppercase;\n    text-align: end;\n    font-size: 20px;\n    font-weight: 600;\n    color: #40ade2;\n    line-height: 1.2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
